import { useMemo } from 'react'
import useVisitTickets from 'core/hooks/member/useVisitTickets'
import MemberTicketDetailsView from 'components/tickets/MemberTicketDetailsView'

type VisitTicketDetailsProps = {
  visitId?: string
}

const VisitTicketDetails = ({ visitId }: VisitTicketDetailsProps) => {
  const { tickets, isLoading, isError } = useVisitTickets(visitId)

  const shouldShow = useMemo(() => {
    return !!visitId && !isLoading && !isError && tickets && tickets.length > 0
  }, [isLoading, isError, tickets, visitId])

  if (!shouldShow) return null

  return (
    <div className="flex flex-col">
      {tickets.map((ticket, index) => (
        <div key={ticket.ticketId}>
          <MemberTicketDetailsView ticketId={ticket.ticketId} ticketData={ticket} />
          {index < tickets.length - 1 && <hr className="my-6 border-neutral-300 border-2" />}
        </div>
      ))}
    </div>
  )
}

export default VisitTicketDetails
